import React, { FC }         from "react";
import { useSelector }       from "react-redux";
import { Form }              from "semantic-ui-react";
import CustomerRecord        from "../../../../domain/record/customer/CustomerRecord";
import WidgetType            from "../../../../domain/record/widget/WidgetType";
import { ResKaState }        from "../../../../index";
import CheckHorizontalWidget from "./widget/CheckHorizontalWidget";
import CheckVerticalWidget   from "./widget/CheckVerticalWidget";
import ImageA4Widget         from "./widget/ImageA4Widget";
import ImageLargeWidget      from "./widget/ImageLargeWidget";
import ImageMediumWidget     from "./widget/ImageMediumWidget";
import ImageSmallWidget      from "./widget/ImageSmallWidget";
import RadioHorizontalWidget from "./widget/RadioHorizontalWidget";
import RadioVerticalWidget   from "./widget/RadioVerticalWidget";
import TextAreaLargeWidget   from "./widget/TextAreaLargeWidget";
import TextAreaMediumWidget  from "./widget/TextAreaMediumWidget";
import TextAreaSmallWidget   from "./widget/TextAreaSmallWidget";
import TextBoxWidget         from "./widget/TextBoxWidget";

const CustomerRecordForm: FC = () => {
  const customerRecord: CustomerRecord = useSelector((state: ResKaState) => state.customerRecord);
  return (
    <>
      <Form>
        {
          customerRecord.template.widgets.toList().map((widget, widgetIndex) => (
            <>
              {
                widget.type.value === WidgetType.TEXT_BOX ?
                  <TextBoxWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.TEXT_AREA_SMALL ?
                  <TextAreaSmallWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.TEXT_AREA_MEDIUM ?
                  <TextAreaMediumWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.TEXT_AREA_LARGE ?
                  <TextAreaLargeWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.RADIO_VERTICAL ?
                  <RadioVerticalWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.RADIO_HORIZONTAL ?
                  <RadioHorizontalWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.CHECK_VERTICAL ?
                  <CheckVerticalWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.CHECK_HORIZONTAL ?
                  <CheckHorizontalWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.IMAGE_SMALL ?
                  <ImageSmallWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.IMAGE_MEDIUM ?
                  <ImageMediumWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.IMAGE_LARGE ?
                  <ImageLargeWidget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
              {
                widget.type.value === WidgetType.IMAGE_A4 ?
                  <ImageA4Widget widgetIndex={ widgetIndex } widget={ widget }/> : null
              }
            </>
          ))
        }
      </Form>
    </>
  );
};

export default CustomerRecordForm;
